import { isTransportOrder, type Order } from '#domain/Order.ts';

export const formatOrderSidebarName = (order?: Order): string | undefined => {
    if (order && !isTransportOrder(order)) {
        return `"${order.number}"`;
    }
    if (order?.customerName && order?.number) {
        return `"${order.number} / ${order.customerName}"`;
    }
};
